import { render, staticRenderFns } from "./containerIndicatorBody.vue?vue&type=template&id=1973c3d4&scoped=true&"
import script from "./containerIndicatorBody.vue?vue&type=script&lang=js&"
export * from "./containerIndicatorBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1973c3d4",
  null
  
)

export default component.exports